import { useTranslation } from '../../hooks/useTranslation';

interface QuickActionsProps {
  onNavigate: (path: string) => void;
}

const QuickActions = ({ onNavigate }: QuickActionsProps) => {
  const { t } = useTranslation();
  
  const actions = [
    {
      label: t('nav.linkExchange'),
      path: '/exchanges?connect=true',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      ),
      gradient: 'from-blue-500 to-blue-600',
    },
    {
      label: t('nav.withdraw'),
      path: '/withdraw',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      gradient: 'from-green-500 to-emerald-600',
    },
    {
      label: t('nav.history'),
      path: '/history',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      gradient: 'from-purple-500 to-purple-600',
    },
    {
      label: t('checkIn.redeem'),
      path: '/check-in',
      icon: (
        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      ),
      gradient: 'from-primary to-yellow-500',
      highlight: true,
    },
  ];

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-white mb-3">{t('common.viewAll')}</h3>
      <div className="grid grid-cols-4 gap-3">
        {actions.map((action) => (
          <button
            key={action.path}
            onClick={() => onNavigate(action.path)}
            className={`rounded-xl p-4 flex flex-col items-center gap-2 transition-all duration-300 active:scale-95 ${
              action.highlight
                ? 'bg-gradient-to-br from-primary/20 to-yellow-500/20 border-2 border-primary hover:shadow-lg hover:shadow-primary/30 hover:scale-105'
                : 'bg-tg-secondary border border-gray-800 hover:border-primary/50 hover:bg-[#2a2a2a] hover:scale-105 hover:shadow-lg hover:shadow-primary/20'
            }`}
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              action.highlight 
                ? `bg-gradient-to-br ${action.gradient} text-white shadow-lg`
                : `bg-gradient-to-br ${action.gradient} text-white shadow-md`
            }`}>
              {action.icon}
            </div>
            <span className={`text-xs font-medium ${action.highlight ? 'text-primary' : 'text-tg-hint'}`}>
              {action.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;
